import { Options } from './script'

export enum ScriptActions {
  GET = 'get',
  SET = 'set',
  UPDATE = 'update'
}

declare global {
  interface Window {
    inoviaLoaded?: boolean
    inovia: (action: ScriptActions, value: Options) => void
    AutomaticSpeechContext: { resume: () => Promise<void>, suspend?: () => Promise<void> | void; }
     __inoviaImeHandlerInstalled?: boolean
  }
}

export enum MessageCategory {
  GREETING = 'GREETING'
}

export enum ChatSessionFlag {
  QUESTION = 'QUESTION',
  FINISH = 'finish',
  TOPIC_CONFIRMATION = 'TOPIC_CONFIRMATION'
}

export type EmphasizeMessage = {
  en_US: string
  [locale: string]: string
}

export enum EventType {
  NEW_SESSION = 'new_session',
  ASSIGNMENT = 'assignment',
  LOADED = 'loaded',
  CONVERSATION_INITIALIZED = 'loaded', //depricated
  USER_MESSAGE = 'user_message' 
}

export enum Sender {
  CUSTOMER = 'CUSTOMER',
  SENDER = 'SENDER',
  AIVA = 'AIVA',
  AGENT = 'AGENT',
  SYSTEM = 'SYSTEM'
}

export enum MessageType {
  OPTIONS = 'options',
  CUSTOM_COMPONENT = 'customComponent',
  MEDIA = 'media',
  HITS = 'hits',
  TEXT = 'text',
  TRIGGER = 'trigger',
  ERROR = 'errorMessage',
  STRING = 'string'
}

export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  EMBEDDED_LINK = 'embeddedLink',
  EMBEDDED_LARGE = 'embeddedLarge',
  PRETTY_LINK = 'prettyLink',
  LINK = 'link'
}

export type Hit = {
  link: string
  title: string
  highlighted: string
  contentType: string
  relative: string
}

export type Message = {
  index: number
  type: MessageType

  sender?: Sender
  message?: string
  timestamp?: number
  requestId?: string

  media_type?: never
  isFailed?: boolean

  options?: string[]

  url?: string
  description?: string
  topic?: string
  error?: string
  hits?: Hit[]
  aivaActive?: boolean
  linkDisplayText?: string
}
// | {
//     type: MessageType.MEDIA
//     media_type: MediaType
//   }
// | {
//     type: MessageType.HITS
//     hits: Hit[]
//     topic: string
//   }

export type EventData = {
  aiva_active?: boolean
  id?: string // sesson id
}

export type Language = {
  locale: string
  label: string
  systemPrompt?: string
  transcriptionUrl?: string
  footerText?: string
  menuText?: string
  termsMessage?:string
}

export type Voice = {
  locale: string
  voice: string
  waitPhrases: string[]
  startTranscribePhrases: string[]
  stopTranscribePhrases: string[]
}

export type Icons = {
  sendIcon: string
  reloadIcon: string
}
export type WSConfig = {
  namespace: string
}

export type WSPublishPayload = {
  messageType: WSPayloadType
  connectionStatus: 'TERMINATED'
  sessionId: string
  message: Record<string, string | undefined | null | number>
  requestId: string
}

export enum WSPayloadType {
  STATUS_MESSAGE = 'connectionStatusMessage',
  USER_MESSAGE = 'agentMessage',
  AGENT_MESSAGE = 'userMessage',
  KEEP_ALIVE = 'clientAliveMessage'
}

export enum PayloadMessageTypes {
  REPLY = 'replyMessage',
  ASSIGNMENT = 'assignmentStatusMessage',
  OPTIONS = 'optionsMessage',
  ERROR = 'errorMessage',
  USER_MESSAGE = 'userMessage'
}

export type PayloadMessage = {
  message: Message
  messageType: PayloadMessageTypes
  linkDisplayText: string
  requestId: string
  error: string
  options: string[]
}

export function installMobileViewportFixes() {
  if (window.__inoviaImeHandlerInstalled) return
  window.__inoviaImeHandlerInstalled = true

  const vv = (window as any).visualViewport as VisualViewport | undefined

  const updateIMEInset = () => {
    if (!vv) return
    const ime = Math.max(0, window.innerHeight - vv.height)
    document.documentElement.style.setProperty('--ime-inset', ime + 'px')
  }

  const onFocusIn = () => {
    // Nudge the focused field into view above the keyboard
    requestAnimationFrame(() => {
      const el = document.activeElement as HTMLElement | null
      if (el?.scrollIntoView) {
        el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
      }
    })
  }

  console.log("Global is run")
  // Initial set + listeners
  updateIMEInset()
  vv?.addEventListener('resize', updateIMEInset)
  vv?.addEventListener('scroll', updateIMEInset)
  document.addEventListener('focusin', onFocusIn)

  // Cleanup on unload (in case of SPA transitions)
  window.addEventListener('beforeunload', () => {
    try {
      vv?.removeEventListener('resize', updateIMEInset)
      vv?.removeEventListener('scroll', updateIMEInset)
      document.removeEventListener('focusin', onFocusIn)
    } catch {}
  })
}

export {}
